import {
  LAMBDATEST_PAUSE_LOADING,
  LAMBDATEST_PAUSE_SUCCESS,
  LAMBDATEST_PAUSE_FAILED,
  LAMBDATEST_PAUSE_CLEAR
} from "./../actionTypeConstants/LambdaTestPauseConstants";

const initialState = {
  testPauseState: {
    loading: false,
    data: null,
    error: null
  }
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LAMBDATEST_PAUSE_LOADING:
      return {
        ...state,
        testPauseState: {
          ...state.testPauseState,
          loading: true,
          data: null,
          error: null
        }
      };
    case LAMBDATEST_PAUSE_SUCCESS:
      return {
        ...state,
        testPauseState: {
          ...state.testPauseState,
          loading: false,
          data: action.result.data,
          error: null
        }
      };
    case LAMBDATEST_PAUSE_FAILED:
      return {
        ...state,
        testPauseState: {
          ...state.testPauseState,
          loading: false,
          error: action.error.response,
          data: null
        }
      };
    case LAMBDATEST_PAUSE_CLEAR:
      return {
        ...state,
        testPauseState: {
          loading: false,
          data: null,
          error: null
        }
      };
    default:
      return state;
  }
}
